import { Layout, Space, Tabs, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import routes from "../../../engine/routes";
import {
  clearBilling,
  getCountType,
  getUniqueInstitutionsBills,
  getUniqueLanguagesInBills,
} from "../Slices/Billing.slice";
import { BillsByType } from "./BillsByType";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import LogHistory from "../../../shared/components/LogHistory";
import { UserContext } from "../../../engine/context/User.context";

const { Content } = Layout;

export function BillingList(props) {
  const { configuration } = useContext(UserContext);

  let defaultTabs = configuration?.bill?.billingMode?.includes("unique")
    ? "unique"
    : "multiple";
  const [activeTab, setActiveTab] = useState(defaultTabs);
  const [year, setYear] = useState(new Date().getFullYear());
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { countType } = useSelector(state => state.billing);

  const handleTabChange = key => {
    setActiveTab(key);
  };

  const getCounts = () => {
    // dispatch(getCountType(year));
  };

  useEffect(() => {
    // getCounts();
  }, [year]);

  useEffect(() => {
    dispatch(getUniqueInstitutionsBills());
    dispatch(getUniqueLanguagesInBills());
    // getCounts();
    return () => {
      dispatch(clearBilling());
    };
  }, []);

  return (
    <Content>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory
          linkType={"detail"}
          route={"/api/bills/xml"}
          label={t("BillingList.recentXmlExport")}
        />
        <LogHistory
          linkType={"detail"}
          route={"/api/bills/xlsx"}
          label={t("BillingList.recentXlsxExport")}
        />
      </ActionRoleSpecific>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          {t("BillingList.title")}
        </Typography.Title>

        <div id={"actionsBills"}></div>
      </Space>

      <div id={"formBills"}></div>
      <Tabs
        defaultActiveKey={defaultTabs}
        onChange={handleTabChange}
        type="card"
        size="large"
        className="prestations-tabs"
      >
        {configuration?.bill?.billingMode?.includes("unique") ? (
          <Tabs.TabPane
            tab={t("BillingList.uniqueBillsTab") + " " + countType.unique}
            key={"unique"}
          >
            {activeTab === "unique" ? (
              <BillsByType
                type="unique"
                key={"unique"}
                name={"unique"}
                isExternal={false}
                setYear={setYear}
              />
            ) : null}
          </Tabs.TabPane>
        ) : null}

        <Tabs.TabPane
          tab={t("BillingList.multipleBillsTab") + " " + countType.multiple}
          key={"multiple"}
        >
          {activeTab === "multiple" ? (
            <BillsByType
              type="multiple"
              key={"multiple"}
              name={"multiple"}
              isExternal={false}
              setYear={setYear}
            />
          ) : null}
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={t("BillingList.externalBillsTab") + " " + countType.external}
          key={"external"}
        >
          {activeTab === "external" ? (
            <BillsByType
              type="unique"
              key={"external"}
              name={"external"}
              isExternal={true}
              setYear={setYear}
            />
          ) : null}
        </Tabs.TabPane>
      </Tabs>
    </Content>
  );
}
